import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Avatar from 'flarum/common/components/Avatar';
export default class LeaderboardTab extends Component {
  view() {
    const {
      userScores,
      myScore,
      hasMore,
      loading,
      onLoadMore
    } = this.attrs;
    const hasData = userScores && userScores.length > 0;
    if (!hasData && !loading) {
      return m("div", {
        className: "LeaderboardTab"
      }, m("p", null, app.translator.trans('huseyinfiliz-pickem.lib.messages.no_data')));
    }
    return m("div", {
      className: "LeaderboardTab"
    }, this.renderMyRankCard(myScore), m("div", {
      className: "Leaderboard"
    }, userScores.length >= 3 && this.renderPodium(userScores.slice(0, 3)), this.renderList(userScores), hasMore && m("div", {
      className: "LoadMore"
    }, m(Button, {
      className: "Button Button--primary",
      loading: loading,
      onclick: onLoadMore
    }, app.translator.trans('huseyinfiliz-pickem.lib.buttons.load_more')))));
  }
  renderMyRankCard(myScore) {
    if (!myScore || !app.session.user) return null;
    const rank = myScore.attribute('rank');
    const points = myScore.totalPoints();
    const correct = myScore.correctPicks();
    const accuracy = myScore.accuracy();
    return m("div", {
      className: "MyRankCard"
    }, m("div", {
      className: "MyRankCard-content"
    }, m("div", {
      className: "MyRankCard-user"
    }, m("div", {
      className: "avatar"
    }, m(Avatar, {
      user: app.session.user,
      className: "Avatar"
    })), m("div", {
      className: "info"
    }, m("span", {
      className: "label"
    }, app.translator.trans('huseyinfiliz-pickem.forum.picks.your_pick')), m("span", {
      className: "rank"
    }, "#", rank))), m("div", {
      className: "MyRankCard-stats"
    }, m("div", {
      className: "stat"
    }, m("span", {
      className: "label"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.points')), m("span", {
      className: "value"
    }, points)), m("div", {
      className: "stat"
    }, m("span", {
      className: "label"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.correct')), m("span", {
      className: "value"
    }, correct)), m("div", {
      className: "stat"
    }, m("span", {
      className: "label"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.accuracy')), m("span", {
      className: "value"
    }, accuracy, "%")))));
  }
  renderPodium(topThree) {
    const medals = ['🥇', '🥈', '🥉'];
    const positions = ['first', 'second', 'third'];
    return m("div", {
      className: "Podium"
    }, topThree.map((score, index) => {
      const user = score && (typeof score.user === 'function' ? score.user() : score.user);
      const totalPoints = typeof score.totalPoints === 'function' ? score.totalPoints() : score.totalPoints;
      const correctPicks = typeof score.correctPicks === 'function' ? score.correctPicks() : score.correctPicks;
      const isMe = app.session.user && user && app.session.user.id() === user.id();
      return m("div", {
        className: `Podium-card ${positions[index]} ${isMe ? 'is-me' : ''}`,
        key: index
      }, m("div", {
        className: "medal"
      }, medals[index]), m("div", {
        className: "rank"
      }, "#", index + 1), m("div", {
        className: "podium-avatar",
        style: {
          marginBottom: '5px'
        }
      }, user ? m(Avatar, {
        user: user,
        className: "Avatar"
      }) : null), m("div", {
        className: "username"
      }, user ? typeof user.displayName === 'function' ? user.displayName() : user.displayName : app.translator.trans('core.lib.username.deleted_text')), m("div", {
        className: "points"
      }, totalPoints, m("small", null, app.translator.trans('huseyinfiliz-pickem.lib.common.points'))), m("div", {
        className: "stats"
      }, m("div", {
        className: "stat"
      }, m("div", {
        className: "label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.correct')), m("div", {
        className: "value"
      }, correctPicks)), m("div", {
        className: "stat"
      }, m("div", {
        className: "label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.accuracy')), m("div", {
        className: "value"
      }, score.accuracy(), "%"))));
    }));
  }
  renderList(userScores) {
    return m("div", {
      className: "PickemList"
    }, m("div", {
      className: "PickemList-header"
    }, m("div", {
      className: "PickemList-cell type-rank"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.rank')), m("div", {
      className: "PickemList-cell type-player"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.player')), m("div", {
      className: "PickemList-cell type-stat"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.points')), m("div", {
      className: "PickemList-cell type-stat"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.correct')), m("div", {
      className: "PickemList-cell type-stat"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.total')), m("div", {
      className: "PickemList-cell type-stat"
    }, app.translator.trans('huseyinfiliz-pickem.lib.headers.accuracy'))), m("div", {
      className: "PickemList-body"
    }, userScores.map((score, index) => {
      const user = score && (typeof score.user === 'function' ? score.user() : score.user);
      const scoreId = score && (typeof score.id === 'function' ? score.id() : score.id) || index;
      const totalPoints = typeof score.totalPoints === 'function' ? score.totalPoints() : score.totalPoints;
      const correctPicks = typeof score.correctPicks === 'function' ? score.correctPicks() : score.correctPicks;
      const totalPicks = typeof score.totalPicks === 'function' ? score.totalPicks() : score.totalPicks;
      const accuracy = typeof score.accuracy === 'function' ? score.accuracy() : 0;
      const isMe = app.session.user && user && app.session.user.id() === user.id();
      return m("div", {
        key: String(scoreId),
        className: `PickemList-item ${index < 3 ? `top-${index + 1}` : ''} ${isMe ? 'is-me' : ''}`
      }, m("div", {
        className: "PickemList-cell type-rank"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.rank')), m("span", {
        className: "value"
      }, "#", index + 1)), m("div", {
        className: "PickemList-cell type-player"
      }, m("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }
      }, user ? m(Avatar, {
        user: user,
        className: "Avatar--small"
      }) : null, m("span", {
        className: "value"
      }, user ? typeof user.displayName === 'function' ? user.displayName() : user.displayName : app.translator.trans('core.lib.username.deleted_text')))), m("div", {
        className: "PickemList-cell type-stat"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.common.points')), m("span", {
        className: "value"
      }, m("strong", null, totalPoints))), m("div", {
        className: "PickemList-cell type-stat"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.correct')), m("span", {
        className: "value"
      }, correctPicks)), m("div", {
        className: "PickemList-cell type-stat"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.total')), m("span", {
        className: "value"
      }, totalPicks)), m("div", {
        className: "PickemList-cell type-stat"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.headers.accuracy')), m("span", {
        className: "value"
      }, accuracy, "%")));
    })));
  }
}
flarum.reg.add('huseyinfiliz-pickem', 'forum/components/LeaderboardTab', LeaderboardTab);